module.exports = __webpack_public_path__ + "static/img/14.b9f0ca6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/14.png
// module id = GT6/
// module chunks = 0